export default "__VITE_ASSET__DVm4NNgq__"